<template>
  <div>
    <div style="text-align: right;">
      <span
        style="float: left; margin-top: 5px;"
        class="ant-descriptions-title"
      >
        Info Leave Day
      </span>
    </div>
    <a-descriptions :column="2">
      <a-descriptions-item label="Total leave day / Tổng số ngày nghỉ phép">
        {{
          employee.annualLeaveDay &&
          (+employee.annualLeaveDay.default / workingHourInDay)
            | numParseFloat(2)
        }}
      </a-descriptions-item>
      <a-descriptions-item
        label="Total leave day remain / Số ngày nghỉ phép còn lại"
      >
        {{
          employee.annualLeaveDay &&
          (+employee.annualLeaveDay.remain / workingHourInDay)
            | numParseFloat(2)
        }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import { workingHourInDay } from "../constants/default";

export default {
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data() {
    return { workingHourInDay };
  },

  methods: {},
};
</script>
<style lang="css" scoped></style>
